exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Divider__root {\n  display: block;\n  flex-shrink: 0;\n  margin: 0;\n  border: none;\n}\n\n.DS__Divider__horizontal {\n  width: 100%;\n  height: 1px;\n}\n\n.DS__Divider__vertical {\n  display: flex;\n  width: 1px;\n  height: 100%;\n  min-height: 1em;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__Divider__root",
	"horizontal": "DS__Divider__horizontal",
	"vertical": "DS__Divider__vertical"
};